import React, { PureComponent } from 'react'
import { string, bool, number, any, func, arrayOf } from 'prop-types'
import { Icon, Text } from 'components'
import { getCurrentPriceUnit, getTotalPrice } from 'utils/prices'
import { priceFormatted } from 'utils/string'

import './PreRaceCard.css'

export class PreRaceCard extends PureComponent {
    static propTypes = {
        groupId: string.isRequired,
        typeId: string.isRequired,
        icon: string.isRequired,
        name: string.isRequired,
        description: any,
        children: any,
        amToolContent: any,
        showAMToolPanel: bool,
        units: number,
        maxUnits: number,
        unitsLeft: number,
        prices: arrayOf(number),
        availableCredits: number,
        selected: bool,
        blocked: bool,
        className: string,
        onSelect: func,
        onSetUnits: func,
        allowPurchaseUnitsInDebt: bool,
        priceInDebt: number,
        unitsLeftAsNormalPrice: number
    }

    static defaultProps = {
        selected: false,
        blocked: false,
        maxUnits: 999999,
        unitsLeft: 0,
        prices: [],
        availableCredits: 999999,
        amToolContent: null,
        showAMToolPanel: false,
        unitsLeftAsNormalPrice: Infinity
    }

    componentWillMount() {
        this.refreshData(this.props)
    }
    componentWillReceiveProps(nextProps) {
        this.refreshData(nextProps)
    }

    refreshData = props => {
        const { units, unitsLeft, unitsLeftAsNormalPrice, prices, priceInDebt } = props
        this.withUnitsSelector = typeof units === 'number'
        this.price = this.withUnitsSelector ? getCurrentPriceUnit(prices, units - unitsLeft, priceInDebt, unitsLeftAsNormalPrice) : null
        this.totalPrice = this.withUnitsSelector ? getTotalPrice(prices, units - unitsLeft, priceInDebt, unitsLeftAsNormalPrice) : null
    }

    handleSelect = () => {
        const { groupId, typeId, icon, blocked, onSelect } = this.props
        if (onSelect && !blocked) {
            onSelect(groupId, typeId, icon)
        }
    }

    handleIncrementUnits = () => this.handleSetUnits(this.props.units + 1)
    handleDecrementUnits = () => this.handleSetUnits(this.props.units - 1)
    handleSetUnits = (nextUnits) => {
        const { groupId, typeId, units, maxUnits, unitsLeft, prices, availableCredits, blocked, onSetUnits, allowPurchaseUnitsInDebt, priceInDebt, unitsLeftAsNormalPrice } = this.props
        if (onSetUnits && !blocked && nextUnits !== units && nextUnits >= 0) {
            if (nextUnits > maxUnits) {
                onSetUnits({ error: 'MAX_UNITS_EXCEED' })
            } else {
                const creditsExceed = nextUnits > units && nextUnits > unitsLeft && this.price > availableCredits
                if (creditsExceed && !allowPurchaseUnitsInDebt) {
                    onSetUnits({ error: 'CREDITS_EXCEED' })
                } else {
                    const currentTotalPrice = getTotalPrice(prices, units - unitsLeft, priceInDebt, unitsLeftAsNormalPrice)
                    const nextTotalPrice = getTotalPrice(prices, nextUnits - unitsLeft, priceInDebt, unitsLeftAsNormalPrice)
                    onSetUnits({
                        groupId,
                        typeId,
                        currentUnits: units,
                        nextUnits,
                        currentTotalPrice,
                        nextTotalPrice,
                        deltaTotalPrice: currentTotalPrice - nextTotalPrice
                    })
                }
            }
        }
    }

    render() {
        const { groupId, typeId, icon, name, description, children, showAMToolPanel, amToolContent, units, maxUnits, unitsLeft, prices, availableCredits, selected, blocked, className, onSelect, onSetUnits, allowPurchaseUnitsInDebt, priceInDebt, unitsLeftAsNormalPrice, ...otherProps } = this.props
        const showSelection = this.withUnitsSelector && (selected || units > 0)
        return (
            <div className={['PreRaceCard flex row-stretch rounded shadow-hover', { Selected: selected, WithSelection: showSelection, Blocked: blocked, ShowAMToolPanel: showAMToolPanel }, className]} {...otherProps}>
                <div className="flex-grow flex row-stretch p-10p" onClick={this.handleSelect}>
                    <div className="PreRaceCard-Icon flex col-center pr-10p">
                        <Icon name={icon} />
                        <Text className="mt-5p">{name}</Text>
                    </div>
                    <div className="PreRaceCard-Body flex-grow flex col-center-stretch py-5p px-25p">
                        {description && <Text tag="div" dangerouslySetInnerHTML={{ __html: description }} />}
                        <div className="PreRaceCard-Content flex col-center-stretch">
                            {children}
                        </div>
                        {!children && this.price && (
                            <div className="flex-self-stretch mt-10p">
                                <Text className="PreRaceCard-Price PerUnit"><strong>{priceFormatted(this.price)}</strong> / unit</Text>
                                <div className="PreRaceCard-Selection flex row-stretch-center">
                                    <Text className="PreRaceCard-Price"><strong>{priceFormatted(this.totalPrice)}</strong> total</Text>
                                    <Text className="PreRaceCard-Price"><strong>{units}</strong> units</Text>
                                </div>
                            </div>
                        )}
                        <div className="PreRaceCard-AMToolPanel flex col-center-left">
                            {amToolContent}
                        </div>
                    </div>
                </div>
                {this.withUnitsSelector && (
                    <div className={['PreRaceCard-UnitsSelector flex col-center', { Show: this.withUnitsSelector && selected }]}>
                        <Icon name="plus-circle" className={{ Disabled: units >= maxUnits || (this.price > availableCredits && typeof allowPurchaseUnitsInDebt !== 'boolean') }} onClick={this.handleIncrementUnits} />
                        <Text className="my-5p">{units}</Text>
                        <Icon name="minus-circle" className={{ Disabled: units <= 0 }} onClick={this.handleDecrementUnits} />
                    </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Cards/PreRaceCard/PreRaceCard.js